const TitlePubDateType = {
	1: {
		key: 1,
		label: 'More Than 3 Months Out',
		class: 'review-lane-left',
		monthsFrom: 3,
		monthsTo: 100,
	},
	2: {
		key: 2,
		label: 'Coming Out Within 3 Months',
		class: 'review-lane-right',
		monthsFrom: 0,
		monthsTo: 3,
	},
	3: {
		key: 3,
		label: 'New in last 6 Months',
		class: 'review-lane-left',
		monthsFrom: -6,
		monthsTo: 0,
	},
	4: {
		key: 4,
		label: 'New over 6 Months Ago',
		class: 'review-lane-right',
		monthsFrom: -200,
		monthsTo: -6,
	},
};

export default TitlePubDateType;
